<nav aria-label="Breadcrumb" class="text-xs text-gray-500 flex items-center space-x-2">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <a
      *ngIf="!last"
      [routerLink]="breadcrumb.url"
      class="hover:text-[#F9992B]"
    >
      {{ breadcrumb.label }}
    </a>
    <span *ngIf="!last">&gt;</span>
    <span *ngIf="last" class="font-bold text-black">{{ breadcrumb.label }}</span>
  </ng-container>
</nav>
